export default "__VITE_ASSET__6da34edd__"